export default "__VITE_ASSET__5fd78413__"